let currentDate = new Date();
let prevMonthDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);

export const DATE_YYYYMM = {
    START_MONTH: 201901,
    CURRENT_MONTH: currentDate.getFullYear() * 100 + currentDate.getMonth() + 1,
    PREV_MONTH:  prevMonthDate.getFullYear() * 100 + prevMonthDate.getMonth() + 1,
    DIVIDEND: 100,
}

export const padZero = (num) => {
    return (num < 10) ? '0' + num.toString() : num.toString();
}

export const diffYYYYMM = (month1, month2) => {
    let date1 = new Date(month1 / 100, month1 % 100);
    let date2 = new Date(month2 / 100, month2 % 100);
    let diff = 0;
    diff += (date2.getFullYear() - date1.getFullYear()) * 12;
    diff += (date2.getMonth() - date1.getMonth());
    return diff;
}

export const addMonthYYYYMM = (startMonth, monthToAdd) => {
    let date = new Date(startMonth / 100, startMonth % 100 - 1 + monthToAdd);
    return date.getFullYear() * 100 + date.getMonth() + 1;
}

export const formatTimeFramesToYYYYMM = (timeFrameIds) => {
    let timeFrameListYYYYMM = [];
    timeFrameIds.map((timeFrame) => {
        if(timeFrame.includes("/")) {
            timeFrameListYYYYMM.push(timeFrame.replace("/", "") - "0");
        } else if(timeFrame.includes("Q")) {
            let year = timeFrame.slice(0,4) - "0";
            let startMonth = (timeFrame.charAt(5) - "1") * 3 + 1;
            [startMonth, startMonth + 1, startMonth + 2].map((month) => {timeFrameListYYYYMM.push(year * 100 + month)})
        } else {
            let year = timeFrame.slice(0,4) - "0";
            Array.from(Array(11).keys()).map(month => {timeFrameListYYYYMM.push(year * 100 + month + 1)})
        }
    });
    return timeFrameListYYYYMM;
};

export const formatTimeFrameToYYYYMM = (timeFrame) => {
    return parseInt(timeFrame.replace('/', ''));
};

export const formatYYYYMMtoTimeFrame = (YYYYMM) => {
    return YYYYMM.substring(0, 4) + '/' + YYYYMM.substring(4);
}

export const MONTH_MAP = Object.freeze({
    '01': 'Jan',
    '02': 'Feb',
    '03': 'Mar',
    '04': 'Apr',
    '05': 'May',
    '06': 'Jun',
    '07': 'Jul',
    '08': 'Aug',
    '09': 'Sep',
    '10': 'Oct',
    '11': 'Nov',
    '12': 'Dec',
});

export const formatDate = (time) => {
    if (time.includes('Q')) {
      return [time.substring(4, 6), time.substring(0, 4)].join(',');
    }
    return [MONTH_MAP[time.substring(4, 6)], time.substring(0, 4)].join(',');
  };

export const YYYYMMDDToFormattedDate = (YYYYMMDD) => {
  YYYYMMDD = YYYYMMDD.toString();
  if(!YYYYMMDD || YYYYMMDD.length < 8) return YYYYMMDD;
  const year = YYYYMMDD.substring(0, 4);
  const month = YYYYMMDD.substring(4, 6);
  const day = YYYYMMDD.substring(6, 8);
  return `${ MONTH_MAP[month] } ${ day }, ${ year }`;
};

export const getShipMonthsFromTimeFrames = (timeFrames) => {
    let months = timeFrames
      .split(',')
      .map(timeFrame =>  timeFrame.trim())
      .filter(timeFrame => timeFrame !== '')
      .map(timeFrame => {
        let timeFrames = [];
        if (timeFrame.length === 4) {
          for(let i = 1; i <= 12; i++) {
            timeFrames.push(`${timeFrame}/${i.toString().padStart(2, '0')}`);
          }
        } else if (timeFrame.length === 6) {
          let parts = timeFrame.split('Q');
          let year = parts[0];
          let quarter = parts[1];
          for (let i = (quarter-1) * 3 + 1; i < quarter * 3 + 1; i++) {
            timeFrames.push(`${year}/${i.toString().padStart(2, '0')}`);
          }
        } else {
          timeFrames.push(timeFrame);
        }
        return timeFrames;
      });
      return _.uniq(months.join().split(','));
  };

export const getEndOfMonthDate = (YYYYMM) => {
  const date = YYYYMMToDate(YYYYMM);
  return new Date(date.getFullYear(), date.getMonth() + 1, 0);
}

export const YYYYMMDDToUnix = (YYYYMMDD) => {
  YYYYMMDD = YYYYMMDD.toString();
  const year = parseInt(YYYYMMDD.substring(0, 4));
  const month = parseInt(YYYYMMDD.substring(4, 6)) - 1; //date month starts from 0
  const day = parseInt(YYYYMMDD.substring(6, 8));
  const date = new Date(year, month, day);
  return dateToUnix(date);
}

export const unixToFormattedDate = (unix) => {
  const date = new Date(unix * 1000);
  const year = date.getFullYear();
  const month = padZero(date.getMonth() + 1 ); //date month starts from 0, whereas MONTH_MAP starts from 01
  const day = padZero(date.getDate());
  return `${ MONTH_MAP[month] } ${ day }, ${ year }`;
}

export const dateToUnix = (date) => {
  return date.getTime()/1000;
}

export const YYYYMMToDate = (YYYYMM) => {
  YYYYMM = YYYYMM.toString();
  return new Date(parseInt(YYYYMM.substring(0, 4)), parseInt(YYYYMM.substring(4,6)) - 1);
}


// WEBPACK FOOTER //
// ./src/utils/date-utils.jsx